export default "__VITE_PUBLIC_ASSET__f54905a9__"